export default __webpack_public_path__ + "mc_vrt_pos.751efa.svg";